module.exports = __webpack_public_path__ + "img/dmitry.b__600x600.648a790a.jpg";